<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="time"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        outlined
        placeholder="- - : - -"
        class="custom-timepicker"
        v-model="time"
        readonly
        v-bind="attrs"
        v-on="on"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-time-picker v-if="modal" v-model="time" full-width :min="disabledTime">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnCancel')}} </v-btn>
      <v-btn text color="primary" @click="clickOk()"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnOk')}} </v-btn>
    </v-time-picker>
  </v-dialog>
</template>
<script>
export default {
    name: 'CustomTimePicker',
    props: {
        value: String,
        placeholder: String,
        rules: Array,
        disabledTimeFrom: String
    },
    watch: {
        disabledTimeFrom: function (value) {
            if (value) {
                this.disabledTime = value
            }
        }
    },
    data: function () {
        return {
            time: null,
            menu: false,
            modal: false,
            disabledTime: null
        }
    },
    created: function () {
        this.time = this.value
        if (this.disabledTimeFrom) {
            this.disabledTime = this.disabledTimeFrom
        }
    },
    methods: {
        clickOk: function () {
            this.$refs.dialog.save(this.time)
            this.$emit('input', this.time)
        }
    }
}
</script>
